import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../_virtual/use-intl.esm.js';
import React from 'react';
import IntlContext from './use-intl.esm8.js';
import getInitializedConfig from './use-intl.esm9.js';

var _excluded = ["children"];
function IntlProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement(IntlContext.Provider, {
    value: getInitializedConfig(props)
  }, children);
}

export { IntlProvider as default };
//# sourceMappingURL=use-intl.esm.js.map
